exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.realtime_echo .dot {\n    display: inline-block;\n    border-radius: 50%;\n    height: 1.5em;\n    width: 1.5em;\n}\n", ""]);

